import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const RTLRoute = ({ children }) => {
  const { user, token } = useSelector(s => s.auth);
  if (!token) return <Navigate to="/login" replace />;
  if (user?.accountType !== 'RTL') return <Navigate to="/" replace />;
  return children;
};

export default RTLRoute;
